import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PropertyRepositoryService extends BaseRepositoryService<
  ModelRegistry['property']
> {
  recordName = 'property';
  implementMethods = [
    'findAll',
    'findRecord',
    'peekAll',
    'unloadAll',
    'peekRecord',
  ];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/property': PropertyRepositoryService;
  }
}
